import { ListRendererFn } from "./ListRenderer";
import styles from "../styles.module.scss";
import React from "react";
import HeroOfferView from "../componentView/HeroOfferView";
import { useSelector } from "react-redux";
import { State } from "core/redux";
import { isValidEntitlement } from "@blacknut/javascript-sdk/dist";
import { isTryBuy } from "src/utils/subscription";

const HeroOfferRenderer: ListRendererFn = ({ list, leaveFor, page }) => {
  const { config, subscription } = useSelector((state: State) => state.globalState);
  const entitlement = subscription.entitlements.find((e) => e.uuid === list.entitlement);
  const hasEntitlement = isValidEntitlement(entitlement) && !isTryBuy(entitlement);

  if (config?.features?.noDynamicPricing || hasEntitlement) {
    return null;
  }

  return (
    <HeroOfferView
      list={list}
      leaveFor={leaveFor}
      key={list.uuid}
      className={styles.hero}
      page={page}
    />
  );
};
export { HeroOfferRenderer };
